class HomePage {
  private modal: Element | null = null;
  private modalClose: Element | null = null;
  private welcomeModal: Element | null = null;
  private welcomeModalButton: Element | null = null;

  constructor() {
    this._init();
  }

  _init() {
    this.modal = document.querySelector('[data-modal="welcome"]');

    this.modalClose = document.querySelector('[data-modal="close"]');
    this.welcomeModal = document.querySelector('[data-modal="first-login"]');
    this.welcomeModalButton = document.querySelector(
      '[data-modal="first-login-close"]'
    );

    this._initModal();
    this._initWelcomeModal();
  }

  _initModal() {
    if (this.modal) {
      this.modalClose?.addEventListener('click', () => {
        this.modal?.classList.toggle('modal--open');
        document.body.style.overflow = 'hidden';
      });
    }
  }

  _initWelcomeModal() {
    // Vérifier si c'est la première connexion
    const isFirstLogin = this._checkFirstLogin();

    if (isFirstLogin && this.welcomeModal) {
      // Afficher la modale de bienvenue
      this.welcomeModal.classList.add('modal--open');
      document.body.style.overflow = 'hidden';

      // Empêcher la fermeture par clic sur l'overlay
      this.welcomeModal.addEventListener('click', (e) => {
        if (e.target === this.welcomeModal) {
          e.preventDefault();
          e.stopPropagation();
        }
      });

      // Gérer le clic sur le bouton "D'accord"
      this.welcomeModalButton?.addEventListener('click', () => {
        this._closeWelcomeModal();
      });
    }
  }

  private _checkFirstLogin(): boolean {
    // Vérifier si l'utilisateur n'a jamais vu la modale de bienvenue
    const hasSeenWelcome = localStorage.getItem('hasSeenWelcomeModal');
    return !hasSeenWelcome;
  }

  private _closeWelcomeModal(): void {
    if (this.welcomeModal) {
      this.welcomeModal.classList.remove('modal--open');
      document.body.style.overflow = 'auto';
      // Marquer comme vue pour ne plus l'afficher
      localStorage.setItem('hasSeenWelcomeModal', 'true');
    }
  }
}

export const homePage = new HomePage();
